import { useState, useEffect } from "react";

const usePicto = (picto: string, pictoTheme: PictoThemes, className = "") => {
    const pictoHeight = picto?.includes("56") ? "56" : (picto?.includes("104") ? "104" : "auto");
    const [pictoComponent, setPictoComponent] = useState(<div style={{ minHeight: `${pictoHeight}px` }}></div>);
    useEffect(() => {
        const importPictoComponent = async () => {
            const module = await require("@able/react/dist/Picto");
            const Picto = module.default;
            const PictoIcon = (module as any)[picto];
            setPictoComponent(<Picto className={className ? className : "ted-ui-checkbox--picto"} theme={pictoTheme}><PictoIcon /></Picto>);
        };
        picto && importPictoComponent();
    }, [picto, pictoTheme]);
    return picto ? pictoComponent : "";
};

export type PictoThemes = "blue" | "green" | "magenta";
export default usePicto;